import { get } from 'lodash';

const selectAllGrants = state => get(state, 'entities.grants.data');
const getIsLoading = state => get(state, 'entities.grants.isLoading');
const getIsLoadingUpward = state => get(state, 'entities.grants.isLoadingUpward');

export {
  selectAllGrants,
  getIsLoading,
  getIsLoadingUpward,
};

export default {
  selectAllGrants,
  getIsLoading,
  getIsLoadingUpward,
};
